import { createContext, useContext } from "react"

export const DialogRootContext = createContext<Element | null | undefined>(
  undefined,
)

export function useDialogRoot(): Element | null | undefined {
  return useContext(DialogRootContext)
}
